var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 20.6667C5.93726 20.6667 1.83334 16.5628 1.83334 11.5C1.83334 6.43726 5.93726 2.33334 11 2.33334C16.0628 2.33334 20.1667 6.43726 20.1667 11.5C20.1667 16.5628 16.0628 20.6667 11 20.6667ZM10.0861 15.1667L16.5669 8.68493L15.2708 7.38876L10.0861 12.5743L7.49284 9.98109L6.19668 11.2773L10.0861 15.1667Z",
    fill: "#00875A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCircleFill);
export default __webpack_public_path__ + "static/media/checkbox_circle_fill.ee7ee4889744711d597c71196ae6fd32.svg";
export { ForwardRef as ReactComponent };